module.exports = __webpack_public_path__ + "img/angle-90.25438437.svg";